import { render } from "./cart-page.vue?vue&type=template&id=032256da&lang=pug"
import script from "./cart-page.vue?vue&type=script&lang=js"
export * from "./cart-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__